export const DEFAULT_CONTEST_DURATION = 7;
export const URGENT_CONTEST_DURATION = 1;
